<span class="ql-font-size-wrapper">
	<input
		#fontSizeInput
		type="text"
		class="ql-font-size-input"
		[class.is-multiple]="isMultiple"
		[(ngModel)]="displayValue"
		[placeholder]="isMultiple ? 'Multiple...' : '16'"
		[title]="isMultiple ? 'Multiple font sizes selected' : 'Font size (px)'"
		(mousedown)="onMouseDown($event)"
		(focus)="onFocus()"
		(blur)="onBlur()"
		(keydown)="onKeydown($event)"
		(input)="onInput($event)"
		maxlength="3"
	/>
	<span class="ql-font-size-label">px</span>
</span>